import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableLanguages',
  initialState: true,
  reducers: {
    setDisableLanguages(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableLanguages } = slice.actions;

export default slice.reducer;
